// @ts-strict-ignore
import update from 'immutability-helper'
import { Action } from 'redux'
import { createAction } from 'redux-actions'
import { ActionWithPayload } from 'types'

export const TOGGLE_DESKTOP_DRAWER = 'flexhire/common/TOGGLE_DESKTOP_DRAWER' as const
export const TOGGLE_MOBILE_DRAWER = 'flexhire/common/TOGGLE_MOBILE_DRAWER' as const
export const SET_HEADER_VARIANT = 'flexhire/common/SET_HEADER_VARIANT' as const
export const SET_LAYOUT_MODE = 'flexhire/common/SET_LAYOUT_MODE' as const
export const SET_DEFAULT_LAYOUT_MODE = 'flexhire/common/SET_DEFAULT_LAYOUT_MODE' as const

export type HeaderVariant = 'default' | 'primary'
export type LayoutMode = 'none' | 'auto'

const DEFAULT_LAYOUT_MODE = 'auto'

const initialState = {
  drawer: {
    mobile: false,
  },
  header: {
    variant: undefined as HeaderVariant,
  },
  mode: DEFAULT_LAYOUT_MODE as LayoutMode,
}

export const toggleMobileDrawer = createAction(TOGGLE_MOBILE_DRAWER) as ({ mobile }: { mobile: boolean }) => ActionWithPayload<typeof TOGGLE_MOBILE_DRAWER, { mobile: boolean }>
export const setHeaderVariant = createAction(SET_HEADER_VARIANT) as ({ variant }: { variant: HeaderVariant }) => ActionWithPayload<typeof SET_HEADER_VARIANT, { variant: HeaderVariant }>
export const setLayoutMode = createAction(SET_LAYOUT_MODE) as ({ mode }: { mode: LayoutMode }) => ActionWithPayload<typeof SET_LAYOUT_MODE, { mode: LayoutMode }>
export const setDefaultLayoutMode = createAction(SET_DEFAULT_LAYOUT_MODE) as () => Action<typeof SET_DEFAULT_LAYOUT_MODE>

type ActionType = ReturnType<typeof toggleMobileDrawer | typeof setHeaderVariant | typeof setLayoutMode | typeof setDefaultLayoutMode>

export default function reducer(state = initialState, action: ActionType) {
  switch (action.type) {
    case TOGGLE_MOBILE_DRAWER:
      return update(state, {
        drawer: {
          mobile: { $set: action.payload.mobile },
        },
      })

    case SET_HEADER_VARIANT:
      return update(state, {
        header: {
          variant: { $set: action.payload.variant },
        },
      })

    case SET_LAYOUT_MODE:
      return update(state, {
        mode: { $set: action.payload.mode },
      })

    case SET_DEFAULT_LAYOUT_MODE:
      return update(state, {
        mode: { $set: DEFAULT_LAYOUT_MODE },
      })

    default:
      return state
  }
}
